import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCurrentDispatchStops extends Layout {
    sourceMovementStops: DataSource;
    tableStops: Table;
}
